import type {
  PropertyAdMediaUpdateRequest,
  PropertyAdInProgressAutosaveRequest,
  PropertyAdInProgressWorkspace,
} from '../types/propertyAdEditor';
import type { ResponseType } from '../types/responses';

import { apiClient } from './apiClient';

const IN_PROGRESS_URL = '/propertyAd/in-progress';

export const propertyAdEditorProvider = {
  getInProgressWorkspace: (): Promise<ResponseType<PropertyAdInProgressWorkspace | null>> =>
    apiClient<PropertyAdInProgressWorkspace | null>(IN_PROGRESS_URL, 'GET'),

  createInProgressWorkspace: (): Promise<ResponseType<PropertyAdInProgressWorkspace>> =>
    apiClient<PropertyAdInProgressWorkspace>(IN_PROGRESS_URL, 'POST'),

  resetInProgressWorkspace: (): Promise<ResponseType<PropertyAdInProgressWorkspace>> =>
    apiClient<PropertyAdInProgressWorkspace>(`${IN_PROGRESS_URL}/reset`, 'POST'),

  autosaveInProgressWorkspace: (
    request: PropertyAdInProgressAutosaveRequest
  ): Promise<ResponseType<PropertyAdInProgressWorkspace>> =>
    apiClient<PropertyAdInProgressWorkspace>(IN_PROGRESS_URL, 'PATCH', request),

  updateInProgressMedia: (
    propertyAdId: string,
    request: PropertyAdMediaUpdateRequest
  ): Promise<ResponseType<PropertyAdInProgressWorkspace>> =>
    apiClient<PropertyAdInProgressWorkspace>(`/propertyAd/${propertyAdId}`, 'PATCH', request),
};
